import React, { useState } from "react";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");

  const handleLogin = (user, userRole) => {
    setUsername(user);
    setRole(userRole);
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setUsername("");
    setRole("");
    setIsLoggedIn(false);
  };

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        minHeight: "100vh",
        backgroundColor: "#f7f9fc",
      }}
    >
      {!isLoggedIn ? (
        <Login onLogin={handleLogin} />
      ) : (
        <Dashboard username={username} role={role} onLogout={handleLogout} />
      )}
    </div>
  );
}

export default App;